import Bus from '../../bus'

import { logger } from '../../utils'

import SettingsManager from '../settings'

import {
  findCategories,
  findEvent,
  findEvents,
  findEventsByTournaments,
  findSports,
  findTournaments,
  searchEvents
} from '../../api/sportsbook'
import UpdatesBroadcaster from './UpdatesBroadcaster'
import SportsbookBroadcaster from './SportsbookBroadcaster'

export default class SportManager {
  constructor () {
    this.sportsbookBroadcaster = new SportsbookBroadcaster()
    this.dataBroadcaster = new UpdatesBroadcaster()
    this.counterBroadcaster = new UpdatesBroadcaster()
    this.statusBroadcaster = new UpdatesBroadcaster()
  }

  /*
    Select sport in active sportsbook
   */
  selectSport (sport) {
    logger.debug('[sport manager]', 'sport selected', sport)

    Bus.send({
      event: Bus.events.sport.sportSelected,
      data: sport
    })
  }

  /*
    Select category in active sportsbook
   */
  selectCategory (category) {
    logger.debug('[sport manager]', 'category selected', category)

    Bus.send({
      event: Bus.events.sport.categorySelected,
      data: category
    })
  }

  /*
    Select tournament in active sportsbook
   */
  selectTournament (tournament) {
    logger.debug('[sport manager]', 'tournament selected', tournament)

    Bus.send({
      event: Bus.events.sport.tournamentSelected,
      data: tournament
    })
  }

  /*
    Select event in active sportsbook
   */
  selectEvent (event) {
    logger.debug('[sport manager]', 'selecting event', event)

    Bus.send({
      event: Bus.events.sport.eventSelected,
      data: event
    })
  }

  // API wrapper for fetching categories
  findCategories (options, signal = null) {
    const { lang } = SettingsManager.settings

    return findCategories({
      signal,
      body: options,
      query: {
        locale: lang
      }
    })
  }

  // API wrapper for fetching tournaments
  findTournaments (options, signal = null) {
    const { lang } = SettingsManager.settings

    return findTournaments({
      signal,
      body: options,
      query: {
        locale: lang
      }
    })
  }

  // API wrapper for fetching events
  findEvents (options, signal = null) {
    const { lang } = SettingsManager.settings

    return findEvents({
      signal,
      body: options,
      query: {
        locale: lang
      }
    })
  }

  findEventsByTournaments (options, signal = null) {
    const { lang } = SettingsManager.settings

    return findEventsByTournaments({
      signal,
      body: options,
      query: {
        locale: lang
      }
    })
  }

  findEvent (eventId, query, signal = null) {
    const { lang } = SettingsManager.settings

    return findEvent(
      eventId,
      {
        locale: lang,
        ...query
      },
      signal
    )
  }

  // API wrapper for fetching sports
  findSports (options, signal = null) {
    const { lang } = SettingsManager.settings

    return findSports({
      signal,
      body: options,
      query: {
        locale: lang
      }
    })
  }

  searchEvents (options, signal = null) {
    const { lang } = SettingsManager.settings

    return searchEvents({
      signal,
      body: options,
      query: {
        locale: lang
      }
    })
  }
}
